<div class="login-container">
    <!-- Header -->
    <header class="login-header">
        <div class="header-inner">
            <!-- Logo -->
            <div class="logo">
                <img src="./assets/log-3.webp" style="height: 42px;width: 42px;" alt="">
                <span>AiEventZo</span>
            </div>

            <!-- Explore Button -->
            <button class="explore-btn" (click)="goToExplore()">
                Explore Events
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
                    <path d="M4 10H16M16 10L11 5M16 10L11 15" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
    </header>


    <!-- Main Content -->
    <div class="login-content">
        <div class="bg-decor">
            <span class="blob blob-blue"></span>
            <span class="blob blob-purple"></span>
        </div>

        <div class="login-card">
            <div class="card-header">
                <h1>Welcome Back</h1>
                <span class="title-accent"></span>

                <p>Please sign in to your account</p>
            </div>

            <form>
                <!-- Login Method Toggle -->
                <div class="login-method-toggle">
                    <button type="button" class="method-btn" [ngClass]="{'active': loginMode === 'password'}"
                        (click)="setLoginMethod('password')">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M15 8V6C15 3.79 13.21 2 11 2C8.79 2 7 3.79 7 6V8M11 13V15M6 18H16C17.1 18 18 17.1 18 16V10C18 8.9 17.1 8 16 8H6C4.9 8 4 8.9 4 10V16C4 17.1 4.9 18 6 18Z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        Password
                    </button>
                    <button type="button" class="method-btn" [ngClass]="{'active': loginMode === 'otp'}"
                        (click)="setLoginMethod('otp')">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M6 2H14C15.1 2 16 2.9 16 4V16C16 17.1 15.1 18 14 18H6C4.9 18 4 17.1 4 16V4C4 2.9 4.9 2 6 2ZM10 15C10.55 15 11 14.55 11 14C11 13.45 10.55 13 10 13C9.45 13 9 13.45 9 14C9 14.55 9.45 15 10 15Z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        OTP
                    </button>
                </div>

                <!-- Mobile Number Input -->
                <div class="form-group">
                    <label for="username">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path
                                d="M14 2H4C2.9 2 2 2.9 2 4V14C2 15.1 2.9 16 4 16H14C15.1 16 16 15.1 16 14V4C16 2.9 15.1 2 14 2ZM9 13C8.45 13 8 12.55 8 12C8 11.45 8.45 11 9 11C9.55 11 10 11.45 10 12C10 12.55 9.55 13 9 13Z"
                                stroke="currentColor" stroke-width="1.5" />
                        </svg>
                        Mobile Number
                    </label>
                    <input type="tel" name="userName" [(ngModel)]="user_name" placeholder="Enter your mobile number"
                        id="username" autocomplete="tel">
                </div>

                <!-- Password Mode -->
                <div *ngIf="loginMode === 'password'" class="form-group">
                    <label for="password">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path
                                d="M14 7V5C14 2.79 12.21 1 10 1C7.79 1 6 2.79 6 5V7M10 11V13M5 16H15C16.1 16 17 15.1 17 14V9C17 7.9 16.1 7 15 7H5C3.9 7 3 7.9 3 9V14C3 15.1 3.9 16 5 16Z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        Password
                    </label>
                    <input type="password" name="password" [(ngModel)]="user_pwd" placeholder="Enter your password"
                        id="password" autocomplete="current-password">
                </div>

                <!-- OTP Mode -->
                <div *ngIf="loginMode === 'otp'" class="otp-section">
                    <button type="button" class="otp-request-btn" (click)="sendOtp(user_name)" [disabled]="otpSent">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M18 2L9 11M18 2L12 18L9 11M18 2L2 8L9 11" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        {{ otpSent ? 'OTP Sent Successfully!' : 'Send OTP' }}
                    </button>

                    <div class="form-group" *ngIf="otpSent">
                        <label for="otp">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path
                                    d="M9 1V3M9 15V17M3.93 3.93L5.34 5.34M12.66 12.66L14.07 14.07M1 9H3M15 9H17M3.93 14.07L5.34 12.66M12.66 5.34L14.07 3.93M13 9C13 11.21 11.21 13 9 13C6.79 13 5 11.21 5 9C5 6.79 6.79 5 9 5C11.21 5 13 6.79 13 9Z"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            </svg>
                            Enter OTP
                        </label>
                        <input type="text" name="otp" [(ngModel)]="otp" placeholder="Enter 4-digit OTP" id="otp"
                            maxlength="4">
                    </div>
                </div>

                <!-- Submit Button -->
                <button type="button" class="submit-btn" (click)="onLogin(user_name, user_pwd, otp)">
                    Sign In
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M4 10H16M16 10L11 5M16 10L11 15" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </form>
        </div>
    </div>

    <!-- Footer -->
    <footer class="login-footer">
        <p>Powered by <strong>V Think Solutions</strong></p>
        <p class="copyright">© 2024 AiEventZo. All rights reserved.</p>
    </footer>
</div>